var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/0/jufa/jufa.cz/node_modules/lodash/_Symbol.js
// module id = 9
// module chunks = 0